const key = value => String(value || "").replace(/\s+/g, "").toUpperCase();
const quality = product => (product.categories?.length || product.categories_ru?.length ? 1000 : 0)
    + (product.description ? 100 : 0) + (product.parameters?.length || 0);

// [[Catalog Prototype]] #obsidian-marker: read saved catalog data, never query suppliers.
export async function enrichPopularComponent(item, search) {
    try {
        const candidates = [];
        let offset = 0;
        while (true) {
            const response = await search({ query: item.part_number, mode: "part", limit: 100, offset });
            const rows = response.items || [];
            candidates.push(...rows.filter(row => key(row.part_number) === key(item.part_number)));
            offset += rows.length;
            if (offset >= response.total || rows.length < 100) break;
            if (offset > 10000) return { ...item, catalog_details_status: "ambiguous" };
        }
        const manufacturer = key(item.manufacturer);
        let matches = candidates;
        if (manufacturer) {
            matches = candidates.filter(row => key(row.manufacturer) === manufacturer);
        } else {
            const makers = new Set(candidates.map(row => key(row.manufacturer)).filter(Boolean));
            if (makers.size > 1) {
                const variants = [...makers].map(maker => {
                    const rows = candidates.filter(row => key(row.manufacturer) === maker);
                    const best = [...rows].sort((a, b) => quality(b) - quality(a) || String(a.id).localeCompare(String(b.id)))[0];
                    return { ...best, suppliers: [...new Set(rows.map(row => row.supplier).filter(Boolean))] };
                }).sort((a, b) => quality(b) - quality(a) || key(a.manufacturer).localeCompare(key(b.manufacturer)));
                return { ...item, ...variants[0], part_number: item.part_number,
                    request_count: item.request_count, last_requested_at: item.last_requested_at,
                    catalog_variants: variants, catalog_details_status: "loaded" };
            }
            if (makers.size === 1) matches = candidates.filter(row => key(row.manufacturer) === [...makers][0]);
        }
        if (!matches.length) return { ...item, catalog_details_status: "missing" };
        // Keep one supplier's specifications together; do not combine conflicting parameters.
        const best = [...matches].sort((a, b) => quality(b) - quality(a) || String(a.id).localeCompare(String(b.id)))[0];
        return { ...item, ...best, id: best.id || item.id || `popular-${item.part_number}`,
            part_number: item.part_number, manufacturer: best.manufacturer || item.manufacturer,
            request_count: item.request_count, last_requested_at: item.last_requested_at,
            suppliers: [...new Set(matches.map(row => row.supplier).filter(Boolean))],
            catalog_details_status: "loaded" };
    } catch {
        return { ...item, catalog_details_status: "unavailable" };
    }
}
